/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface EntitiesAccount {
    access?: ModelAccess
    id?: string
    needPaymentInfo?: boolean
}

export interface EntitiesAddPaymentMethodResponse {
    url?: string
}

export interface EntitiesAssistRequest {
    input?: string
    mode?: EntitiesMode
}

export interface EntitiesAssistResponse {
    output?: string
}

export interface EntitiesBatchCreateVMRequest {
    vms?: EntitiesCreateVMRequest[]
}

export interface EntitiesBatchCreateVMResponse {
    ids?: number[]
}

export interface EntitiesCheckoutCallbackResponse {
    amountInBaisa?: number
    paymentStatus?: PlatformPkgThawaniCheckoutPaymentStatus
}

export interface EntitiesCheckoutRequest {
    amountInBaisa?: number
    baseURL?: string
}

export interface EntitiesCheckoutResponse {
    sessionID?: number
    url?: string
}

export interface EntitiesCreateLeadRequest {
    email: string
    info?: Record<string, any>
}

export interface EntitiesCreateOdooRequest {
    dedicated?: boolean
    domainName?: string
    https?: ModelHttps
    keyPairName?: string
    name?: string
    stagingEnvCount?: number
    volumeSize?: number
    workerCount?: number
}

export interface EntitiesCreateOdooResponse {
    id?: number
}

export interface EntitiesCreateSMERequest {
    company?: string
    crNumber?: string
    email?: string
    fieldOfWork?: string
    name?: string
    phone?: string
    smeNumber?: string
}

export interface EntitiesCreateVMRequest {
    keyPairName?: string
    name?: string
    os?: ModelOS
    osami?: string
    vmType?: ModelVMType
    volumeSize?: number
}

export interface EntitiesCreateVMResponse {
    id?: number
}

export interface EntitiesImage {
    description?: string
    id?: string
    name?: string
}

export interface EntitiesImportKeyPairRequest {
    name?: string
    public?: string
}

export interface EntitiesInvoice {
    amount?: number
    date?: string
    id?: number
}

export interface EntitiesKeyPair {
    id?: number
    name?: string
}

export interface EntitiesListImageResponse {
    items?: EntitiesImage[]
}

export interface EntitiesListInvoicesResponse {
    invoices?: EntitiesInvoice[]
}

export interface EntitiesListKeyPairResponse {
    items?: EntitiesKeyPair[]
}

export interface EntitiesListOdooResponse {
    items?: EntitiesOdoo[]
}

export interface EntitiesListPaymentMethodsResponse {
    paymentMethods?: EntitiesPaymentMethod[]
}

export interface EntitiesListTransactionsResponse {
    transactions?: EntitiesTransaction[]
}

export interface EntitiesListVMResponse {
    items?: EntitiesVM[]
}

export interface EntitiesMeResponse {
    accounts?: EntitiesAccount[]
    balance?: number
    company?: string
    fieldOfWork?: string
    name?: string
    needPaymentInfo?: boolean
    phoneNumber?: string
    title?: string
}

export enum EntitiesMode {
    ModeTranslateArabicEnglish = 'TranslateArabicEnglish',
    ModeTranslateEnglishArabic = 'TranslateEnglishArabic',
    ModeSummarize = 'Summarize',
    ModeProofread = 'Proofread',
}

export interface EntitiesOdoo {
    dedicated?: boolean
    domain_name?: string
    https?: ModelHttps
    id?: number
    ipAddress?: string
    keyPairName?: string
    name?: string
    stagingEnvCount?: number
    status?: string
    vm_type?: ModelVMType
    volumeSize?: number
    workerCount?: number
}

export interface EntitiesPaymentMethod {
    brand?: string
    cardType?: string
    id?: string
    maskedCard?: string
    nickname?: string
}

export interface EntitiesRoleAssignment {
    access?: ModelAccess
    updatedAt?: string
    user_id?: string
}

export interface EntitiesRoleAssignmentDeleteRequest {
    user_id?: string
}

export interface EntitiesRoleAssignmentRequest {
    access?: ModelAccess
    user_id?: string
}

export interface EntitiesS3EndpointResponse {
    api?: string
    console?: string
    password?: string
    username?: string
}

export interface EntitiesSendTicketRequest {
    content?: string
    id?: number
    newTicket?: boolean
    title?: string
}

export interface EntitiesSignUpEmailRequest {
    email?: string
}

export interface EntitiesStartVMRequest {
    id?: number
}

export interface EntitiesStartVMResponse {
    id?: number
}

export interface EntitiesTicket {
    account_id?: string
    created_at?: string
    id?: number
    title?: string
    updated_at?: string
    user_id?: string
}

export interface EntitiesTicketMessage {
    account_id?: string
    created_at?: string
    id?: number
    message_content?: string
    receiving?: boolean
    updated_at?: string
    user_id?: string
}

export interface EntitiesTransaction {
    amount?: number
    createdAt?: string
    id?: number
    productId?: number
    productType?: ModelProductType
}

export interface EntitiesUpdatePaymentProfileRequest {
    companyAddress?: string
    companyName?: string
}

export interface EntitiesUpdateProfileRequest {
    company?: string
    fieldOfWork?: string
    name?: string
    phoneNumber?: string
    title?: string
}

export interface EntitiesUsePromoCodeRequest {
    code?: string
}

export interface EntitiesUsePromoCodeResponse {
    applied?: boolean
    newBalance?: number
}

export interface EntitiesUserBalance {
    balance?: number
    id?: string
}

export interface EntitiesVM {
    id?: number
    ipAddress?: string
    keyPairName?: string
    name?: string
    os?: ModelOS
    osAMI?: string
    status?: string
    vmType?: ModelVMType
    volumeSize?: number
}

export enum ModelAccess {
    AccessOwner = 'owner',
    AccessAdmin = 'admin',
    AccessEditor = 'editor',
    AccessViewer = 'viewer',
}

export interface ModelHttps {
    certificate?: string
    httpsOptions?: ModelHttpsMode
    key?: string
}

export enum ModelHttpsMode {
    HttpsModeDISABLED = 'DISABLED',
    HttpsModeLETSENCRYPT = 'LETSENCRYPT',
    HttpsModeCUSTOMERCERTIFICATE = 'CUSTOMER_CERTIFICATE',
}

export enum ModelOS {
    OSUbuntu = 'Ubuntu',
}

export enum ModelProductType {
    ProductTypeCompute = 'Compute',
    ProductTypeDataTransfer = 'DataTransfer',
    ProductTypeIPAddress = 'IPAddress',
    ProductTypeVolume = 'Volume',
    ProductTypeCharge = 'Charge',
    ProductTypeLLMManagement = 'LLMManagement',
}

export enum ModelVMType {
    VMTypeBurstable2Core4GB = 'VMType_Burstable_2core_4GB',
    VMTypeBurstable4Core16GB = 'VMType_Burstable_4core_16GB',
    VMTypeComputeOptimized8Core16GB = 'VMType_ComputeOptimized_8core_16GB',
    VMTypeMemoryOptimized8Core32GB = 'VMType_MemoryOptimized_8core_32GB',
    VMTypeGraphicOptimized8Core32GB = 'VMType_GraphicOptimized_8core_32GB',
    VMTypeMemoryIntensive8Core64GB = 'VMType_MemoryIntensive_8core_64GB',
    VMTypeMemoryIntensive16Core128GB = 'VMType_MemoryIntensive_16core_128GB',
    VMTypeComputeOptimized48Core96GB = 'VMType_ComputeOptimized_48core_96GB',
}

export enum PlatformPkgThawaniCheckoutPaymentStatus {
    PaymentStatusUnpaid = 'unpaid',
    PaymentStatusPaid = 'paid',
    PaymentStatusCancelled = 'cancelled',
}

import axios, {
    AxiosInstance,
    AxiosRequestConfig,
    AxiosResponse,
    HeadersDefaults,
    ResponseType,
} from 'axios'

export type QueryParamsType = Record<string | number, any>

export interface FullRequestParams
    extends Omit<
        AxiosRequestConfig,
        'data' | 'params' | 'url' | 'responseType'
    > {
    /** set parameter to `true` for call `securityWorker` for this request */
    secure?: boolean
    /** request path */
    path: string
    /** content type of request body */
    type?: ContentType
    /** query params */
    query?: QueryParamsType
    /** format of response (i.e. response.json() -> format: "json") */
    format?: ResponseType
    /** request body */
    body?: unknown
}

export type RequestParams = Omit<
    FullRequestParams,
    'body' | 'method' | 'query' | 'path'
>

export interface ApiConfig<SecurityDataType = unknown>
    extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
    securityWorker?: (
        securityData: SecurityDataType | null
    ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void
    secure?: boolean
    format?: ResponseType
}

export enum ContentType {
    Json = 'application/json',
    FormData = 'multipart/form-data',
    UrlEncoded = 'application/x-www-form-urlencoded',
    Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
    public instance: AxiosInstance
    private securityData: SecurityDataType | null = null
    private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
    private secure?: boolean
    private format?: ResponseType

    constructor({
        securityWorker,
        secure,
        format,
        ...axiosConfig
    }: ApiConfig<SecurityDataType> = {}) {
        this.instance = axios.create({
            ...axiosConfig,
            baseURL: axiosConfig.baseURL || 'https://salehkhazaei.ir',
        })
        this.secure = secure
        this.format = format
        this.securityWorker = securityWorker
    }

    public setSecurityData = (data: SecurityDataType | null) => {
        this.securityData = data
    }

    protected mergeRequestParams(
        params1: AxiosRequestConfig,
        params2?: AxiosRequestConfig
    ): AxiosRequestConfig {
        const method = params1.method || (params2 && params2.method)

        return {
            ...this.instance.defaults,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...((method &&
                    this.instance.defaults.headers[
                        method.toLowerCase() as keyof HeadersDefaults
                    ]) ||
                    {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        }
    }

    protected stringifyFormItem(formItem: unknown) {
        if (typeof formItem === 'object' && formItem !== null) {
            return JSON.stringify(formItem)
        } else {
            return `${formItem}`
        }
    }

    protected createFormData(input: Record<string, unknown>): FormData {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key]
            const propertyContent: any[] =
                property instanceof Array ? property : [property]

            for (const formItem of propertyContent) {
                const isFileType =
                    formItem instanceof Blob || formItem instanceof File
                formData.append(
                    key,
                    isFileType ? formItem : this.stringifyFormItem(formItem)
                )
            }

            return formData
        }, new FormData())
    }

    public request = async <T = any, _E = any>({
        secure,
        path,
        type,
        query,
        format,
        body,
        ...params
    }: FullRequestParams): Promise<AxiosResponse<T>> => {
        const secureParams =
            ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (await this.securityWorker(this.securityData))) ||
            {}
        const requestParams = this.mergeRequestParams(params, secureParams)
        const responseFormat = format || this.format || undefined

        if (
            type === ContentType.FormData &&
            body &&
            body !== null &&
            typeof body === 'object'
        ) {
            body = this.createFormData(body as Record<string, unknown>)
        }

        if (
            type === ContentType.Text &&
            body &&
            body !== null &&
            typeof body !== 'string'
        ) {
            body = JSON.stringify(body)
        }

        return this.instance.request({
            ...requestParams,
            headers: {
                ...(requestParams.headers || {}),
                ...(type ? { 'Content-Type': type } : {}),
            },
            params: query,
            responseType: responseFormat,
            data: body,
            url: path,
        })
    }
}

/**
 * @title Platform API
 * @version 1.0
 * @baseUrl https://salehkhazaei.ir
 * @contact
 */
export class Api<
    SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
    api = {
        /**
         * No description
         *
         * @tags user
         * @name V1AssistCreate
         * @summary Assist
         * @request POST:/api/v1/assist
         */
        v1AssistCreate: (
            request: EntitiesAssistRequest,
            params: RequestParams = {}
        ) =>
            this.request<EntitiesAssistResponse, any>({
                path: `/api/v1/assist`,
                method: 'POST',
                body: request,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1BillingCheckoutCreate
         * @summary Checkout
         * @request POST:/api/v1/billing/checkout
         */
        v1BillingCheckoutCreate: (
            request: EntitiesCheckoutRequest,
            params: RequestParams = {}
        ) =>
            this.request<EntitiesCheckoutResponse, any>({
                path: `/api/v1/billing/checkout`,
                method: 'POST',
                body: request,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1BillingCheckoutCallbackCreate
         * @summary CheckoutCallback
         * @request POST:/api/v1/billing/checkout/{session_id}/callback
         */
        v1BillingCheckoutCallbackCreate: (
            sessionId: string,
            params: RequestParams = {}
        ) =>
            this.request<EntitiesCheckoutCallbackResponse, any>({
                path: `/api/v1/billing/checkout/${sessionId}/callback`,
                method: 'POST',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1BillingInvoicesList
         * @summary InvoiceList
         * @request GET:/api/v1/billing/invoices
         */
        v1BillingInvoicesList: (params: RequestParams = {}) =>
            this.request<EntitiesListInvoicesResponse, any>({
                path: `/api/v1/billing/invoices`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags billing
         * @name V1BillingInvoicesPdfDetail
         * @summary GetInvoicePDF
         * @request GET:/api/v1/billing/invoices/{id}/pdf
         */
        v1BillingInvoicesPdfDetail: (id: string, params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/billing/invoices/${id}/pdf`,
                method: 'GET',
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1BillingPaymentMethodsList
         * @summary ListPaymentMethods
         * @request GET:/api/v1/billing/payment_methods
         */
        v1BillingPaymentMethodsList: (params: RequestParams = {}) =>
            this.request<EntitiesListPaymentMethodsResponse, any>({
                path: `/api/v1/billing/payment_methods`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1BillingPaymentMethodsCreate
         * @summary AddPaymentMethod
         * @request POST:/api/v1/billing/payment_methods
         */
        v1BillingPaymentMethodsCreate: (params: RequestParams = {}) =>
            this.request<EntitiesAddPaymentMethodResponse, any>({
                path: `/api/v1/billing/payment_methods`,
                method: 'POST',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags billing
         * @name V1BillingPromoUseCreate
         * @summary UsePromoCode
         * @request POST:/api/v1/billing/promo/use
         */
        v1BillingPromoUseCreate: (
            request: EntitiesUsePromoCodeRequest,
            params: RequestParams = {}
        ) =>
            this.request<EntitiesUsePromoCodeResponse, any>({
                path: `/api/v1/billing/promo/use`,
                method: 'POST',
                body: request,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1BillingTransactionsList
         * @summary ListTransactions
         * @request GET:/api/v1/billing/transactions
         */
        v1BillingTransactionsList: (
            query?: {
                /** User email to impersonate */
                user?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<EntitiesListTransactionsResponse, any>({
                path: `/api/v1/billing/transactions`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1KeypairDelete
         * @summary DeleteKeyPair
         * @request DELETE:/api/v1/keypair
         */
        v1KeypairDelete: (
            query: {
                /** ID */
                id: number
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/api/v1/keypair`,
                method: 'DELETE',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1KeypairImportCreate
         * @summary ImportKeyPair
         * @request POST:/api/v1/keypair/import
         */
        v1KeypairImportCreate: (
            request: EntitiesImportKeyPairRequest,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/api/v1/keypair/import`,
                method: 'POST',
                body: request,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1KeypairsList
         * @summary ListKeyPair
         * @request GET:/api/v1/keypairs
         */
        v1KeypairsList: (params: RequestParams = {}) =>
            this.request<EntitiesListKeyPairResponse, any>({
                path: `/api/v1/keypairs`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1LeadCreate
         * @summary CreateLead
         * @request POST:/api/v1/lead
         */
        v1LeadCreate: (
            request: EntitiesCreateLeadRequest,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/api/v1/lead`,
                method: 'POST',
                body: request,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1LoginEmailCreate
         * @summary LoginEmail
         * @request POST:/api/v1/login/email
         */
        v1LoginEmailCreate: (
            request: EntitiesSignUpEmailRequest,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/api/v1/login/email`,
                method: 'POST',
                body: request,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1MeList
         * @summary GetMe
         * @request GET:/api/v1/me
         */
        v1MeList: (params: RequestParams = {}) =>
            this.request<EntitiesMeResponse, any>({
                path: `/api/v1/me`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1MeCreate
         * @summary UpdateProfile
         * @request POST:/api/v1/me
         */
        v1MeCreate: (
            request: EntitiesUpdateProfileRequest,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/api/v1/me`,
                method: 'POST',
                body: request,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1MePaymentCreate
         * @summary UpdatePaymentProfile
         * @request POST:/api/v1/me/payment
         */
        v1MePaymentCreate: (
            request: EntitiesUpdatePaymentProfileRequest,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/api/v1/me/payment`,
                method: 'POST',
                body: request,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1OdooDelete
         * @summary DeleteOdoo
         * @request DELETE:/api/v1/odoo
         */
        v1OdooDelete: (
            query: {
                /** ID */
                id: number
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/api/v1/odoo`,
                method: 'DELETE',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1OdooCreateCreate
         * @summary CreateOdoo
         * @request POST:/api/v1/odoo/create
         */
        v1OdooCreateCreate: (
            request: EntitiesCreateOdooRequest,
            params: RequestParams = {}
        ) =>
            this.request<EntitiesCreateOdooResponse, any>({
                path: `/api/v1/odoo/create`,
                method: 'POST',
                body: request,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1OdoosList
         * @summary ListOdoo
         * @request GET:/api/v1/odoos
         */
        v1OdoosList: (params: RequestParams = {}) =>
            this.request<EntitiesListOdooResponse, any>({
                path: `/api/v1/odoos`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1RoleAssignmentList
         * @summary ListRole
         * @request GET:/api/v1/role/assignment
         */
        v1RoleAssignmentList: (params: RequestParams = {}) =>
            this.request<EntitiesRoleAssignment[], any>({
                path: `/api/v1/role/assignment`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1RoleAssignmentCreate
         * @summary AssignRole
         * @request POST:/api/v1/role/assignment
         */
        v1RoleAssignmentCreate: (
            request: EntitiesRoleAssignmentRequest,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/api/v1/role/assignment`,
                method: 'POST',
                body: request,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1RoleAssignmentDelete
         * @summary DeleteRole
         * @request DELETE:/api/v1/role/assignment
         */
        v1RoleAssignmentDelete: (
            request: EntitiesRoleAssignmentDeleteRequest,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/api/v1/role/assignment`,
                method: 'DELETE',
                body: request,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1S3List
         * @summary S3Endpoint
         * @request GET:/api/v1/s3
         */
        v1S3List: (params: RequestParams = {}) =>
            this.request<EntitiesS3EndpointResponse, any>({
                path: `/api/v1/s3`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1S3Create
         * @summary EnableS3
         * @request POST:/api/v1/s3
         */
        v1S3Create: (params: RequestParams = {}) =>
            this.request<void, any>({
                path: `/api/v1/s3`,
                method: 'POST',
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1SmeCreate
         * @summary CreateSME
         * @request POST:/api/v1/sme
         */
        v1SmeCreate: (
            request: EntitiesCreateSMERequest,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/api/v1/sme`,
                method: 'POST',
                body: request,
                type: ContentType.Json,
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1TicketList
         * @summary ListTicket
         * @request GET:/api/v1/ticket
         */
        v1TicketList: (params: RequestParams = {}) =>
            this.request<EntitiesTicket[], any>({
                path: `/api/v1/ticket`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1TicketCreate
         * @summary CreateTicket
         * @request POST:/api/v1/ticket
         */
        v1TicketCreate: (
            request: EntitiesSendTicketRequest,
            query?: {
                /** Service name */
                service?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<number, any>({
                path: `/api/v1/ticket`,
                method: 'POST',
                query: query,
                body: request,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1TicketDetail
         * @summary GetTicket
         * @request GET:/api/v1/ticket/{id}
         */
        v1TicketDetail: (id: string, params: RequestParams = {}) =>
            this.request<EntitiesTicketMessage[], any>({
                path: `/api/v1/ticket/${id}`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1UsersList
         * @summary ListUsers
         * @request GET:/api/v1/users
         */
        v1UsersList: (params: RequestParams = {}) =>
            this.request<EntitiesUserBalance[], any>({
                path: `/api/v1/users`,
                method: 'GET',
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1VmDelete
         * @summary DeleteVM
         * @request DELETE:/api/v1/vm
         */
        v1VmDelete: (
            query: {
                /** ID */
                id: number
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/api/v1/vm`,
                method: 'DELETE',
                query: query,
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1VmCreateCreate
         * @summary CreateVM
         * @request POST:/api/v1/vm/create
         */
        v1VmCreateCreate: (
            request: EntitiesCreateVMRequest,
            query?: {
                /** User email to impersonate */
                user?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<EntitiesCreateVMResponse, any>({
                path: `/api/v1/vm/create`,
                method: 'POST',
                query: query,
                body: request,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1VmCreateBatchCreate
         * @summary BatchCreateVM
         * @request POST:/api/v1/vm/create/batch
         */
        v1VmCreateBatchCreate: (
            request: EntitiesBatchCreateVMRequest,
            query?: {
                /** User email to impersonate */
                user?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<EntitiesBatchCreateVMResponse, any>({
                path: `/api/v1/vm/create/batch`,
                method: 'POST',
                query: query,
                body: request,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1VmOsList
         * @summary ListOS
         * @request GET:/api/v1/vm/os
         */
        v1VmOsList: (
            query: {
                /** Description filter */
                filter: string
            },
            params: RequestParams = {}
        ) =>
            this.request<EntitiesListImageResponse, any>({
                path: `/api/v1/vm/os`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1VmStartCreate
         * @summary StartVM
         * @request POST:/api/v1/vm/start
         */
        v1VmStartCreate: (
            request: EntitiesStartVMRequest,
            query?: {
                /** User email to impersonate */
                user?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<EntitiesStartVMResponse, any>({
                path: `/api/v1/vm/start`,
                method: 'POST',
                query: query,
                body: request,
                type: ContentType.Json,
                format: 'json',
                ...params,
            }),

        /**
         * No description
         *
         * @tags user
         * @name V1VmsList
         * @summary ListVM
         * @request GET:/api/v1/vms
         */
        v1VmsList: (
            query?: {
                /** User email to impersonate */
                user?: string
            },
            params: RequestParams = {}
        ) =>
            this.request<EntitiesListVMResponse, any>({
                path: `/api/v1/vms`,
                method: 'GET',
                query: query,
                format: 'json',
                ...params,
            }),
    }
}
